var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEventsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180 550 c0 -29 -2 -30 -42 -30 -24 0 -49 -4 -56 -8 -9 -7 -12 -59 -10 -228 l3 -219 225 -3 c124 -1 235 0 248 3 22 5 22 6 22 224 0 243 4 231 -71 231 -37 0 -39 2 -39 30 0 23 -4 30 -20 30 -16 0 -20 -7 -20 -30 l0 -30 -100 0 -100 0 0 30 c0 23 -4 30 -20 30 -16 0 -20 -7 -20 -30z m0 -85 c0 -18 5 -25 20 -25 15 0 20 7 20 25 l0 25 100 0 100 0 0 -25 c0 -18 5 -25 20 -25 15 0 20 7 20 26 0 23 3 25 38 22 35 -3 37 -5 40 -40 l3 -38 -220 0 -221 0 0 33 c0 19 3 37 7 40 3 4 21 7 40 7 29 0 33 -3 33 -25z m358 -227 l-3 -143 -215 0 -215 0 -3 143 -3 142 221 0 221 0 -3 -142z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventsIcon);
export default __webpack_public_path__ + "static/media/events-icon.47e98acc2450513b115a8fd37cc936e1.svg";
export { ForwardRef as ReactComponent };